/**
 * Control styled components (buttons, inputs, indicators)
 */

import styled from "styled-components/macro";
import { Box, IconButton } from "@material-ui/core";

export const ActionButton = styled(IconButton)`
  padding: 4px;
  &:hover {
    background-color: ${(props) => props.theme.palette.action.hover};
  }
`;

export const ColumnFilterButton = styled(Box)`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
  margin-left: 4px;
  font-size: 0.7rem;
  background-color: ${(props) =>
    props.$active
      ? props.theme.palette.primary.main
      : props.theme.palette.action.hover};
  color: ${(props) =>
    props.$active
      ? props.theme.palette.primary.contrastText
      : props.theme.palette.text.secondary};
  &:hover {
    background-color: ${(props) =>
      props.$active
        ? props.theme.palette.primary.dark
        : props.theme.palette.action.selected};
  }
`;
